import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
} from "react-bootstrap";
import { FloatNumericInput, FloatSelect, HeadPage } from "src/componentes";
import TributacaoCfopImpostoCadastroCode from "./TributacaoCfopImpostoCadastro.Code";

const TributacaoCfopImpostoCadastroView = () => {
  const code = TributacaoCfopImpostoCadastroCode();

  return (
    <Container>
      <Form noValidate onSubmit={code.form.handleSubmit(code.onSubmit)}>
        <HeadPage headText="Imposto Cadastro">
          {code.menu.menuItens !== undefined &&
            code.menu.menuItens.map((item) => (
              <Dropdown.Item
                key={item.id}
                onClick={code.menu.handleMenuClick(item)}
              >
                {item.nome}
              </Dropdown.Item>
            ))}
        </HeadPage>
        {!code.loading ? (
          <>
            <Row>
              <Col>
                <Col xs={12}>
                  <FloatSelect
                    label="CST/CSOSN"
                    options={code.getCstOptions(code.type)}
                    register={code.form.register("cst")}
                    errorsMessage={code.form.formState.errors.cst}
                    tooltipMessage="Código tributário do imposto."
                    onSelect={(value: string | number) =>
                      code.setSelectedCSTValue(Number(value))
                    }
                  />
                </Col>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                {(() => {
                  switch (code.selectedCSTValue) {
                    case 101:
                      return (
                        <FloatNumericInput
                          label="Alíquota Simples Nacional (%)"
                          control={code.form.control}
                          name="aliquotaSimples"
                          errorsMessage={
                            code.form.formState.errors.aliquotaSimples
                          }
                        />
                      );
                    case 2:
                      return <div>Exibindo conteúdo para a opção 2</div>;
                    case 3:
                      return <div>Exibindo conteúdo para a opção 3</div>;
                    default:
                      return (
                        <div>Selecione uma opção para ver o conteúdo.</div>
                      );
                  }
                })()}
              </Col>
            </Row>

            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button type="submit">Confirmar</Button>
              </Col>
            </Row>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default TributacaoCfopImpostoCadastroView;
